import { FormGroupInput, Card, DropDown, Button } from '@/plugins/paper-components/index'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, max } from 'vee-validate/dist/rules'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
    extend('required', required)
    extend('max', max)

    Vue.component('fg-input', FormGroupInput)
    Vue.component('drop-down', DropDown)
    Vue.component('card', Card)
    Vue.component('p-button', Button)
    Vue.component('ValidationProvider', ValidationProvider)
    Vue.component('ValidationObserver', ValidationObserver)
  }
}

export default GlobalComponents
